import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';

const Profile: React.FC = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState<{
    username: string;
    email: string;
    mobile: string;
    address: string;
    city: string;
    state: string;
    pincode: string;
  } | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchUser = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        if (data.success && data.user) {
          setUserData({
            username: data.user.username,
            email: data.user.email,
            mobile: data.user.mobile,
            address: data.user.address,
            city: data.user.city,
            state: data.user.state,
            pincode: data.user.pincode,
          });
        } else {
          navigate('/login');
        }
      } catch {
        navigate('/login');
      }
    };

    fetchUser();
  }, [navigate]);

  if (!userData) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500">Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto mt-24 px-4">
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="p-6 border-b flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-indigo-100 flex items-center justify-center text-2xl font-bold text-indigo-600 uppercase">
            {userData.username?.charAt(0)}
          </div>
          <div>
            <h2 className="text-xl font-semibold text-indigo-700">{userData.username}</h2>
            <p className="text-sm text-gray-500">{userData.email}</p>
          </div>
        </div>

        <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div>
            <label className="block text-xs text-gray-500">Mobile Number</label>
            <p className="text-sm font-medium text-gray-800">{userData.mobile}</p>
          </div>

          <div>
            <label className="block text-xs text-gray-500">Pincode</label>
            <p className="text-sm font-medium text-gray-800">{userData.pincode}</p>
          </div>

          <div>
            <label className="block text-xs text-gray-500">City</label>
            <p className="text-sm font-medium text-gray-800">{userData.city}</p>
          </div>

          <div>
            <label className="block text-xs text-gray-500">State</label>
            <p className="text-sm font-medium text-gray-800">{userData.state}</p>
          </div>

          <div className="sm:col-span-2">
            <label className="block text-xs text-gray-500">Full Address</label>
            <p className="text-sm font-medium text-gray-800 whitespace-pre-wrap">{userData.address}</p>
          </div>
        </div>

        <div className="bg-gray-50 p-4 text-right">
          <a
            href="/settings/edit-profile"
            className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 text-sm rounded-lg font-medium transition"
          >
            ✏️ Edit Profile
          </a>
        </div>
      </div>
    </div>
  );
};

export default Profile;
